import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import {
  CompHeading, DecorativeLink, ListingTable, PageHeader, Section
} from '@budget-monorepo/shared-ui';
import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';
import './downloads.scss';

// eslint-disable-next-line react/prop-types
const Segment = ({ title, rows }) => (
  <Section>
    <CompHeading title={title} />
    <ListingTable rows={rows} />
  </Section>
);

// eslint-disable-next-line react/prefer-stateless-function
const DownloadsPage = (props) => {
  const { data } = props;
  const { content, site } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent;
  const layoutProps = {
    activeIndex: 0,
    // eslint-disable-next-line react/prop-types
    above: () => <PageHeader title={content.title} category={content.budgetSection} />,
    pageTitle: content.title,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  // Convert query results to object keyed by filename.
  const files = {};
  data.allFile.edges.forEach(({ node }) => {
    files[node.base] = node.publicURL;
  });
  // metadata for the page
  const metaTitle = content.title;
  const metaDescription = 'Download the documents and data sets for the governor\'s budget recommendation.';
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        metaType: 'dataset',
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        {content.sections.map((section, index) => {
          const sectionTitle = section.title;
          const rows = section.listing.map((listing) => ({
            label: listing.title,
            items: [
              listing.file ? <DecorativeLink text={listing.file} info={listing.title} href={files[listing.file]} showFileIcon /> : <DecorativeLink text={listing.name} info={listing.name} href={listing.href} showFileIcon />
            ]
          }));
          const sectionProps = {
            title: sectionTitle,
            rows
          };
          // eslint-disable-next-line react/no-array-index-key
          return<Segment key={`ma__downloads-section-${index}`} {...sectionProps} />;
        })}
      </Layout>
    </Fragment>
  );
};

DownloadsPage.propTypes = {
  data: PropTypes.object
};

export default DownloadsPage;

export const query = graphql`
  query DownloadsPageQuery {
    site {
      ...SiteMetadata
    }
    content: pagesJson(fields: { slug: { eq: "/downloads/" } }) {
      title
      budgetSection
      sections {
        title
        listing {
          # For an internal link to a file download
          title
          file
          # For an external link / remove comment if you are inc. one
          # href
          # name
        }
      }
      # Get the last modified timestamp for the file powering the page
      ...PagesJsonDataTimeStamp
    }
    allFile(filter: { sourceInstanceName: { eq: "downloads" } }) {
      edges {
        node {
          base
          publicURL
        }
      }
    }
  }
`;
